
export const toRadians = (degrees: number): number => {
  return degrees * Math.PI / 180
}

export const toDegrees = (radians: number): number => {
  return radians * 180 / Math.PI
}

export const randomNumber = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min) + min)
}